import React, {useState} from 'react';
import './styles.css';
import {AiAssitantChatMessage} from '../../../data/models/AI/AiAssistantModels';
import Lottie from 'lottie-react';
import {loadingLottie, typingLoadingLottie} from '../../../assets/lottie';
import Tooltip from '../../../uiToolkit/Tooltip';
import {aiAssitantChatbotText} from '../aiAssistantChatbotText';

type AiAssistantChatbotUIType = 'page' | 'widget';
interface Props {
  chat: AiAssitantChatMessage[];
  onSendMessage: (message: string) => void;
  isLoading: boolean;
  isSendingMessage: boolean;
  assistantTitle: string;
  assistantAvatar?: string;
  onClearAssistantChat: () => void;
  uiType?: AiAssistantChatbotUIType;
}

const AiAssistnatChatbotUI = React.memo(
  ({
    chat,
    onSendMessage,
    isLoading,
    isSendingMessage,
    assistantTitle,
    assistantAvatar,
    onClearAssistantChat,
    uiType = 'widget',
  }: Props) => {
    const [currentMessage, setCurrentMessage] = useState('');

    const onSend = () => {
      if (currentMessage && !isSendingMessage) {
        onSendMessage(currentMessage);
        setCurrentMessage('');
      }
    };

    const listenForEnterInput = (e: any) => {
      if (e.key == 'Enter') {
        onSend();
      }
    };

    const renderUserMessage = (chat: AiAssitantChatMessage) => (
      <>
        {chat.assistant_response ? (
          <div className="Chatbox-conversation Chatbox-ai">
            <div className="AiAvatarContainer">
              <span className="icon-ai_assistant_ic"></span>
            </div>
            <div>
              <p>{chat.assistant_response}</p>
            </div>
          </div>
        ) : (
          <div className="Chatbox-conversation Chatbox-ai">
            <div className="AiAvatarContainer">
              <Lottie
                animationData={typingLoadingLottie}
                loop={true}
                style={{transform: 'scale(2.8)'}}
              />
            </div>
            <div>
              <h5>{aiAssitantChatbotText.thinking}</h5>
            </div>
          </div>
        )}
        <div className="Chatbox-conversation Chatbox-user">
          <div>
            <p>{chat.learner_question}</p>
          </div>
        </div>
      </>
    );

    return (
      <div
        className={`AiAssistantChatboxContainer ${
          uiType === 'widget'
            ? 'AiAssistantChatboxContainerWidget'
            : 'AiAssistantChatboxContainerPage'
        }`}>
        <div className="AiAssistantChatboxHeader">
          {assistantAvatar ? (
            <img src={assistantAvatar} />
          ) : (
            <span className="icon-ai_assistant_ic"></span>
          )}
          <span>{assistantTitle}</span>
          <Tooltip tooltipText={aiAssitantChatbotText.clearTooltip}>
            <button onClick={onClearAssistantChat} className="EraseButton">
              <span className="icon-eraser"></span>
            </button>
          </Tooltip>
        </div>
        <div className="AiAssistantChatboxBody">
          <div className="AiAssistantChatlist">
            {isLoading ? (
              <div className="LoaderContainer">
                <Lottie
                  animationData={loadingLottie}
                  loop={true}
                  style={{width: '34px', height: '34px'}}
                />
              </div>
            ) : chat.length ? (
              [...chat].reverse().map(renderUserMessage)
            ) : (
              <div className="EmptyStateContainer">
                <span className="empty">
                  {aiAssitantChatbotText.you_can_start_typing}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="AiAssistantChatboxFooter">
          <input
            type="text"
            className="chat-input"
            placeholder="Write your message"
            value={currentMessage}
            onKeyDown={listenForEnterInput}
            onChange={e => setCurrentMessage(e.target.value)}
            maxLength={1000}
          />
          <button onClick={onSend} disabled={isLoading}>
            <span className="icon-send"></span>
          </button>
        </div>
      </div>
    );
  },
);

export default AiAssistnatChatbotUI;
